import React, { useEffect, useState } from "react";
import { getCallRoutes } from "../utilities/genesysCloudUtils";
import "../App.css";
import { DataTable, DxButton } from "genesys-react-components";
import { Loading } from "./Loading";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function CallRoutes({
  divisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  setOpts,
  filters,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [callRoutes, setCallRoutes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    generateCallRoutes();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setOpts({ dnis: "", name: "" });
    setPageNumber(1);
    setTabName("call-routes-tab");
    setIsVisible({ divisions: false, object: true, applyButton: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    generateCallRoutes();
    console.log("Generating Call Routes with filters:", filters);
  }, [filters.dnis, filters.name]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateCallRoutes = (resetPage = false) => {
    setLoading(true);

    const currentPage = resetPage ? 1 : pageNumber;

    if (resetPage && pageNumber !== 1) {
      setPageNumber(1);
    }

    let body = {
      pageSize: 100, // Number | Page size
      pageNumber: currentPage,
      sortBy: "name", // String | Sort by
      sortOrder: "ASC", // String | Ascending or descending sort order
    };

    if (filters.dnis && filters.dnis.length > 0) {
      body.dnis = filters.dnis;
    }

    if (filters.name && filters.name.length > 0) {
      body.name = `*${filters.name}*`;
    }

    getCallRoutes(body, divisions).then((data) => {
      setCallRoutes(data.entities);
      setPageCount(data.pageCount);
      setLoading(false);
    });
  };

  const tableProps = {
    className: "table",
    headerRow: {
      cells: [
        {
          content: "",
          align: "center",
          className: "select-column",
        },
        {
          content: "Route Name",
          align: "center",
        },
        {
          content: "Division",
          align: "center",
        },
        {
          content: "Flow - Open",
          align: "center",
        },
        {
          content: "DNIS",
          align: "center",
        },
        {
          content: "Route Id",
          align: "center",
        },
      ],
    },
    indentation: 0,
    rows: callRoutes.map((route) => {
      return {
        cells: [
          {
            renderedContent: (
              <input
                aria-label={`Select ${route.name} for export`}
                checked={Boolean(selectedExportRows[route.id])}
                onChange={(event) => onToggleExportRow(route, event.target.checked)}
                type="checkbox"
              />
            ),
            content: selectedExportRows[route.id] ? "selected" : "",
            align: "center",
            className: "select-column",
          },
          {
            content: route.name,
            align: "left",
          },
          {
            content: route.division.name,
            align: "left",
          },
          {
            content: route.openHoursFlow.name,
            align: "center",
          },
          {
            renderedContent: (
              <>
                {route.dnis
                  .map((dnis, index) => dnis.split("+1")[1])
                  .sort((a, b) =>
                    a.localeCompare(b, undefined, { numeric: true })
                  )
                  .map((number, idx) => (
                    // number
                    // <DxButton key={idx} type="primary" className="schedule-inactive">
                    <DxButton
                      key={idx}
                      type="primary"
                      className={`call-route-number${filters.dnis &&
                          filters.dnis.length > 0 &&
                          number.includes(filters.dnis)
                          ? ""
                          : "-unfiltered"
                        }`}
                    >
                      {number}
                    </DxButton>
                  ))}
              </>
            ),
            content:
              ": " +
              route.dnis
                .map((dnis, index) => dnis.split("+1")[1])
                .sort((a, b) =>
                  a.localeCompare(b, undefined, { numeric: true })
                )
                .join(", "),
            align: "left",
          },
          {
            renderedContent: <kbd className="kbd">{route.id}</kbd>,
            content: route.id,
            align: "left",
          },
        ],
      };
    }),
  };
  const allVisibleSelected = callRoutes.length > 0 && callRoutes.every((route) => selectedExportRows[route.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      loading={loading}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: callRoutes })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(callRoutes, checked)}
      rowCount={callRoutes.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Call Routes"
    >
      {loading && <Loading text="Loading Call Routes..." />}
      {!loading && callRoutes && (
        <DataTable
          sortable={true}
          filterable={false}
          headerRow={tableProps.headerRow}
          rows={tableProps.rows}
          className="call-route-table table-pin-rows"
        />
      )}

      {/* {callRoutes ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Count</th>
                <th>Route Name</th>
                <th>Division</th>
                <th>Flow - Open</th>
                <th>DNIS</th>
                <th>Route Id</th>
              </tr>
            </thead>
            <tbody>
              {callRoutes.map((callRoute, index) => {
                return (
                  <tr key={callRoute.id}>
                    <th className="index">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>{callRoute.name}</td>
                    <td>{callRoute.division.name}</td>
                    <td>{callRoute.openHoursFlow.name}</td>
                    <td>
                      {callRoute.dnis.map((dnis, index) => dnis.split("+1")[1]).join(", ")}
                    </td>
                    <td>
                      <kbd className="kbd">{callRoute.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )} */}
    </CatalogTableSurface>
  );
}
